import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServerlessProvider } from './serverless';
import { SystemDashboardHistoriesApiRequest } from './models/system-dashboard-histories-api-request';
import { SystemDashboardHistoriesApiResponse } from './models/system-dashboard-histories-api-response';
import { SystemDashboardDispatchHistory } from "./models/system-dashboard-dispatch-history";
import { GenericItem } from './models/generic-item';
import { TimeUtil } from '../../utilities/time-util';

/**
 * [システム][ダッシュボード]配車履歴一覧 APIの通信用プロバイダー.
 */
@Injectable()
export class SystemDashboardHistoriesServiceProvider {

  /** APIのパス */
  private readonly PATH = '/v3/system/dashboardHistories';

  /** 要変換プロパティ */
  private readonly CONVERSION = {
    date: [
      'historyCreatedAt',
      'requestFixedDt',
      'pickUpPlanDt',
      'dropOffPlanDt'
    ]
  };

  constructor(public serverless: ServerlessProvider) { }

  /**
   * 配車履歴一覧を取得する.
   *
   * @param userIds ユーザーIDの一覧
   * @param vehicleIds 車両IDの一覧
   * @param startDt 検索範囲開始日 (yyyy/MM/dd HH:mm:ss)
   * @param endDt 検索範囲終了日 (yyyy/MM/dd HH:mm:ss)
   * @param getCountNumber 取得要素数
   * @param offsetNumber オフセット番号
   * @returns 配車履歴一覧, 配車成功回数（当日）, 配車総数（当日）
   */
  public get(userIds: number[], vehicleIds: number[], startDt: string, endDt: string, getCountNumber: number, offsetNumber: number): Observable<[SystemDashboardDispatchHistory[], number, number]> {
    const requestBody: SystemDashboardHistoriesApiRequest = {
      userIds: userIds,
      vehicleIds: vehicleIds,
      startDt: startDt,
      endDt: endDt,
      getCountNumber: getCountNumber,
      offsetNumber: offsetNumber
    };

    return this.serverless.postApi<SystemDashboardHistoriesApiRequest, GenericItem<SystemDashboardHistoriesApiResponse>>
      (this.PATH, requestBody).map((responseBody) => this.toModel(responseBody));
  }

  /**
   * レスポンスボディをモデルに変換する.
   *
   * @param responseBody レスポンスボディ
   * @returns 配車履歴一覧, 配車成功回数（当日）, 配車総数（当日）
   */
  private toModel(responseBody: GenericItem<SystemDashboardHistoriesApiResponse>): [SystemDashboardDispatchHistory[], number, number] {
    const dispatchHistories = responseBody.item.dispatchHistories.map((historyResponse) => {
      const history = {} as SystemDashboardDispatchHistory;
      for (const key in historyResponse) {
        if (this.CONVERSION.date.indexOf(key) >= 0) {
          history[key] = TimeUtil.toDate(historyResponse[key]);
          continue;
        }

        history[key] = historyResponse[key];
      }

      return history;
    });

    return [dispatchHistories, responseBody.item.dispatchSuccessCount, responseBody.item.dispatchTotalCount];
  }
}



// WEBPACK FOOTER //
// ./src/providers/servicer/system-dashboard-histories-service.ts